var $ = require('jquery');

$(".dd-map__trigger--worldwide").click(function() {
  $(".dd-map__trigger--europe").removeClass('is-active');
  $(".dd-map__europe").removeClass('is-active');
  $(".dd-map__trigger--worldwide").addClass('is-active');
  $(".dd-map__world").addClass('is-active');
});

$(".dd-map__trigger--europe").click(function() {
  $(".dd-map__trigger--europe").addClass('is-active');
  $(".dd-map__europe").addClass('is-active');
  $(".dd-map__trigger--worldwide").removeClass('is-active');
  $(".dd-map__world").removeClass('is-active');
});


var mapItems = $('.dd-sales__item');
mapItems.each(function(){
  var item = $(this);
  var marker = item.find('.dd-sales__marker');
  var close = item.find('.dd-sales__close');
  marker.click(function() {
    mapItems.removeClass('is-active');
    item.addClass('is-active');
  });
  close.click(function() {
    mapItems.removeClass('is-active');
  });

});


var europeMarker = $('.dd-map__marker--europe');
europeMarker.click(function() {
  $(".dd-map__trigger--europe").addClass('is-active');
  $(".dd-map__europe").addClass('is-active');
  $(".dd-map__trigger--worldwide").removeClass('is-active');
  $(".dd-map__world").removeClass('is-active');
});